module.exports = __webpack_public_path__ + "img/magento-support-security.3034b5d9.webp";